interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, totalPages: number): number[] {
  const pages: number[] = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) {
    pages.push(i);
  }
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = buildPages(page, totalPages);

  return (
    <div className="flex items-center justify-center gap-2 flex-wrap mt-8">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="px-3 h-9 rounded-md bg-background-100 border border-background-200/70 text-sm text-foreground-700 hover:bg-background-200/70 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line" />
      </button>

      {pages[0] > 1 && <span className="text-foreground-500 text-sm px-1">…</span>}

      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
            item === page
              ? "bg-primary-500 text-background-50 font-semibold"
              : "bg-background-100 border border-background-200/70 text-foreground-700 hover:bg-background-200/70"
          }`}
        >
          {item}
        </button>
      ))}

      {pages[pages.length - 1] < totalPages && (
        <span className="text-foreground-500 text-sm px-1">…</span>
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="px-3 h-9 rounded-md bg-background-100 border border-background-200/70 text-sm text-foreground-700 hover:bg-background-200/70 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}